import MuiSkeleton from '@material-ui/lab/Skeleton';

export default MuiSkeleton;
